import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import Loading from 'components/Messages/Loading/Loading';
import Error from 'components/Messages/Error/Error';
import { TagsContextProvider, useTagsContext } from 'pages/Tags/tags.context';
import TagsTable from 'pages/Tags/Table';
import TagGroupsTable from 'pages/TagGroups/Table';
import { TagGroupsContextProvider } from 'pages/TagGroups/tagGroups.context';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import CreateTag from 'pages/Tags/CreateTag';
import CreateTagGroup from 'pages/TagGroups/CreateTagGroup';
import { Div } from 'components/Elements/Div/Div';

const TagsComponent = (): JSX.Element => {
  const { loading, error } = useTagsContext();
  const [showTags, setShowTags] = useState(true);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error message='There was an error loading Tags' />;
  }

  return (
    <>
      <SectionHeader
        pageHeader
        title={
          <Div display='flex' alignItems='flex-end' gap='0.75rem'>
            <Button onClick={() => setShowTags(true)} variant={showTags ? 'contained' : 'outlined'}>
              Tags
            </Button>
            <Button
              onClick={() => setShowTags(false)}
              variant={showTags ? 'outlined' : 'contained'}
            >
              Tag Groups
            </Button>
          </Div>
        }
        actions={showTags ? <CreateTag /> : <CreateTagGroup />}
      />
      <Grid container alignItems='center'>
        <Grid item xs={12}>
          {showTags ? <TagsTable /> : <TagGroupsTable />}
        </Grid>
      </Grid>
    </>
  );
};

// wrapping component in context provider for full access
const Tags = () => (
  <TagGroupsContextProvider>
    <TagsContextProvider>
      <TagsComponent />
    </TagsContextProvider>
  </TagGroupsContextProvider>
);

export default Tags;
